import React from "react";

import { useNavigate } from "react-router-dom";
import StatsTable from "./components/statsTable";
import ProfilePicture from "./components/profilePicture";
import { sortByWinAndLoss } from "./utils";


type Props = {
    currentPlayerName: string;
    games: any;
};

const OpponentTable = ({ currentPlayerName, games }: Props) => {
    const navigate = useNavigate();

    var opponents: { [key: string]: { win_count: number; lose_count: number } } = {};

    for (var key in games) {
        var game = games[key];

        var opponent = null;
        var currentPlayerTeam = null;

        // Check if the current player is in team_blue
        for (const player in game.team_blue) {
            if (player === currentPlayerName) {
                currentPlayerTeam = "blue";
                break;
            }
        }

        // Check if the current player is in team_red
        if (!currentPlayerTeam) {
            for (const player in game.team_red) {
                if (player === currentPlayerName) {
                    currentPlayerTeam = "red";
                    break;
                }
            }
        }

        // Determine if the current player's team won
        var teamWon = game.winner.toLowerCase() === currentPlayerTeam;

        // Process opponents
        if (currentPlayerTeam === "blue") {
            for (const player in game.team_red) {
                opponent = player;
                if (opponent in opponents) {
                    opponents[opponent].win_count += teamWon ? 1 : 0;
                    opponents[opponent].lose_count += teamWon ? 0 : 1;
                } else {
                    opponents[opponent] = {
                        win_count: teamWon ? 1 : 0,
                        lose_count: teamWon ? 0 : 1,
                    };
                }
            }
        } else if (currentPlayerTeam === "red") {
            for (const player in game.team_blue) {
                opponent = player;
                if (opponent in opponents) {
                    opponents[opponent].win_count += teamWon ? 1 : 0;
                    opponents[opponent].lose_count += teamWon ? 0 : 1;
                } else {
                    opponents[opponent] = {
                        win_count: teamWon ? 1 : 0,
                        lose_count: teamWon ? 0 : 1,
                    };
                }
            }
        }
    }

    const sortedOpponents = sortByWinAndLoss(opponents);

    const profileOnClicked = (name: string) => {
        window.scrollTo(0, 0);
        navigate(`/players/${name}`)
    };

    return (
        <StatsTable header={"Opponents"} leftColumn={"Opponent"}>
            {sortedOpponents.map(([opponent, stats]) => (
                <tr key={opponent}>
                    <td className="profile-cell" onClick={() => profileOnClicked(opponent)}>
                        <ProfilePicture
                            playerName={opponent}
                        />
                    </td>
                    <td>{stats.win_count}</td>
                    <td>{stats.lose_count}</td>
                    <td>
                        {(
                            (stats.win_count /
                                (stats.win_count + stats.lose_count)) *
                            100
                        ).toFixed(0)}
                        %
                    </td>
                </tr>
            ))}
        </StatsTable>
    );
};

export default OpponentTable;